/**
 * File search.js.
 *
 * Show/hide advanced search panel; manage advanced search options and empty searches.
 * Track search events.
 */
(function () {
  // search form w/in page body
  var mainSearch = document.querySelector('main .search-form');
  if(mainSearch){
    var mainSearchInput = mainSearch.querySelector('[type=search]');
    mainSearch.addEventListener('submit', function (e) {
      // on empty search, search for "Commonwealth"
      if (mainSearchInput.value === '') {
        mainSearchInput.value = 'Commonwealth';
        // e.stopPropagation();
        // e.preventDefault();
        // mainSearchInput.setAttribute('placeholder', 'Please enter a search term')
      }
    })

    var options = document.getElementById('js-search-options').querySelectorAll('[type=radio],[type=checkbox]');
    options.forEach(function (option) {
      option.addEventListener('change', function (e) {
        if (e.target.type === 'checkbox') {
          var allCheckboxes = e.target.closest('.option-group').querySelectorAll('input');
          var checkedVals = Array.from(allCheckboxes, node => node.checked);
          var allSelectionCheckbox = e.target.closest('.option-group').querySelector('.all-selection');
          // if it's the 'all sections/cats' checkbox, and we've just checked it, uncheck all others
          if (e.target.classList.contains('all-selection') && e.target.checked) {
            allCheckboxes.forEach(function (node) {
              if (node !== e.target) {
                node.checked = false;
                node.parentElement.classList.remove('selected');
              }
            })
          }
          // if it's not the 'all sections' checkbox, make sure the 'all sections' checkbox is unchecked/un'.selected'
          if (!e.target.classList.contains('all-selection')) {
            allSelectionCheckbox.checked = false;
            allSelectionCheckbox.parentNode.classList.remove('selected');
          }
          // if no boxes are checked, check the 'all sections' box
          if (!checkedVals.includes(true)) {
            allSelectionCheckbox.checked = true;
            allSelectionCheckbox.parentNode.classList.add('selected');
          }
        } else { // else it's a radio
          var allRadios = e.target.closest('.option-group').querySelectorAll('input');
          allRadios.forEach(function (node) {
            if (node !== e.target) {
              node.checked = false;
              node.parentElement.classList.remove('selected');
            }
          })
        }
        // add/remove 'selected' from parent label for radios OR checkboxes
        e.target.checked ? e.target.parentElement.classList.add('selected') : e.target.parentElement.classList.remove('selected');
      })
    });

    // Show/hide advanced search options
    const drawerTransitioner = transitionHiddenElement({
      element: document.querySelector('.js-drawer'),
      visibleClass: 'is-open'
    });

    var searchFieldEl = document.querySelector('main .search-field');
    searchFieldEl.addEventListener('focus', () => {
      drawerTransitioner.show()
      document.querySelector('main .search-form').classList.add('has-focus')
    });

    document.querySelector('main .search-form .close').addEventListener('click', () => {
      drawerTransitioner.hide()
      document.querySelector('main .search-form').classList.remove('has-focus')
    });

    document.addEventListener('click', (e) => {
      const isDescendant = document.querySelector('main .search-form').contains(e.target);
      if (!isDescendant) {
        drawerTransitioner.hide()
      }
    })
  } // end if search field in body

  /** 
   * Tracking for searches happens on search results page
   */
	// how can we track where search came from? Add url param?
	let params = (new URL(document.location)).searchParams;
  if(params){
    let searchTerm = params.get('s');
    if(searchTerm){
      let searchSort = params.get('sort') ? params.get('sort') : '';
      let searchSource = params.get('src') ? params.get('src') : ''
      // searchSections, searchCategories and numSearchResults are set via PHP in search.php
      if(searchSections !== '' || searchCategories !== ''){
        // track advanced search
        gtag('event', 'cw_search_advanced', {
          'event_category': 'search',
          'event_label': `${searchTerm}|${searchSort}|${searchSections}|${searchCategories}|${searchSource}`,
          'value': numSearchResults
        });
      } else {
        // if search only has search string param
        // track a simple search
        gtag('event', 'cw_search_simple', {
          'event_category': 'search',
          'event_label': `${searchTerm}|${searchSort}|${searchSource}`,
          'value': numSearchResults
        });
      }
    }
  }

  /** 
   * Library code
   * Using https://www.npmjs.com/package/@cloudfour/transition-hidden-element
   */

  function transitionHiddenElement({
    element,
    visibleClass,
    waitMode = 'transitionend',
    timeoutDuration,
    hideMode = 'hidden',
    displayValue = 'block'
  }) {
    if (waitMode === 'timeout' && typeof timeoutDuration !== 'number') {
      console.error(`
      When calling transitionHiddenElement with waitMode set to timeout,
      you must pass in a number for timeoutDuration.
    `);

      return;
    }

    // Don't wait for exit transitions if a user prefers reduced motion.
    // Ideally transitions will be disabled in CSS, which means we should not wait
    // before adding `hidden`.
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      waitMode = 'immediate';
    }

    /**
     * An event listener to add `hidden` after our animations complete.
     * This listener will remove itself after completing.
     */
    const listener = e => {
      // Confirm `transitionend` was called on  our `element` and didn't bubble
      // up from a child element.
      if (e.target === element) {
        applyHiddenAttributes();

        element.removeEventListener('transitionend', listener);
      }
    };

    const applyHiddenAttributes = () => {
      if (hideMode === 'display') {
        element.style.display = 'none';
      } else {
        element.setAttribute('hidden', true);
      }
    }

    const removeHiddenAttributes = () => {
      if (hideMode === 'display') {
        element.style.display = displayValue;
      } else {
        element.removeAttribute('hidden');
      }
    }

    return {
      /**
       * Show the element
       */
      show() {
        /**
         * This listener shouldn't be here but if someone spams the toggle
         * over and over really fast it can incorrectly stick around.
         * We remove it just to be safe.
         */
        element.removeEventListener('transitionend', listener);

        /**
         * Similarly, we'll clear the timeout in case it's still hanging around.
         */
        if (this.timeout) {
          clearTimeout(this.timeout);
        }

        removeHiddenAttributes();

        /**
         * Force a browser re-paint so the browser will realize the
         * element is no longer `hidden` and allow transitions.
         */
        const reflow = element.offsetHeight;

        element.classList.add(visibleClass);
      },

      /**
       * Hide the element
       */
      hide() {
        if (waitMode === 'transitionend') {
          element.addEventListener('transitionend', listener);
        } else if (waitMode === 'timeout') {
          this.timeout = setTimeout(() => {
            applyHiddenAttributes();
          }, timeoutDuration);
        } else {
          applyHiddenAttributes();
        }

        // Add this class to trigger our animation
        element.classList.remove(visibleClass);
      },

      /**
       * Toggle the element's visibility
       */
      toggle() {
        if (this.isHidden()) {
          this.show();
        } else {
          this.hide();
        }
      },

      /**
       * Tell whether the element is hidden or not.
       */
      isHidden() {
        /**
         * The hidden attribute does not require a value. Since an empty string is
         * falsy, but shows the presence of an attribute we compare to `null`
         */
        const hasHiddenAttribute = element.getAttribute('hidden') !== null;

        const isDisplayNone = element.style.display === 'none';

        const hasVisibleClass = [...element.classList].includes(visibleClass);

        return hasHiddenAttribute || isDisplayNone || !hasVisibleClass;
      },

      // A placeholder for our `timeout`
      timeout: null
    };
  }
  /* end library code */

}());